import { userDataApi } from './api';

export const getPrivateInfo = () =>
  userDataApi.get('fetch', {
    relayOn: [{ url: 'save', method: 'post', baseURL: userDataApi.defaults.baseURL }],
  });

export const savePrivateInfo = (data) =>
  userDataApi.post('save', data, { important: true, stack: true });
